import type { AssignCarrierRequest } from "api-client";
import type { AssignCarrierSubmitPayload, BookingRow } from "design-components";
import { isMultiPieceBooking } from "design-components";

/** Maps drawer submit payload to assign-carrier request body (FR-AV75-001–003, FR-AV168-001–002). */
export function buildAssignCarrierRequest(
  bookingId: number,
  payload: AssignCarrierSubmitPayload,
  row?: Pick<BookingRow, "quantity">,
): AssignCarrierRequest {
  const carrier =
    payload.mode === "existingCarrier"
      ? {
          carrierId: resolveExistingCarrierId(payload.carrierId),
          carrierInfo: null,
        }
      : buildInviteCarrierPayload(payload);

  const body: AssignCarrierRequest = { bookingId, carrier };

  if (row && isMultiPieceBooking(row)) {
    if (payload.quantity == null || payload.quantity < 1) {
      throw new Error("Quantity is required for multi-piece bookings.");
    }
    body.quantity = payload.quantity;
  } else if (payload.quantity != null && payload.quantity > 0) {
    body.quantity = payload.quantity;
  }

  return body;
}

function resolveExistingCarrierId(carrierId: string): number {
  const parsed = Number(carrierId);
  if (!Number.isFinite(parsed)) {
    throw new Error("Invalid carrier id.");
  }
  return parsed;
}

function buildInviteCarrierPayload(payload: Extract<AssignCarrierSubmitPayload, { mode: "invitedCarrier" }>) {
  const hasFederalDot = payload.ifCarrierHasFederalDot;
  const safetyRaw = payload.safetyScore.trim();
  const safetyScore = hasFederalDot && safetyRaw ? Number(safetyRaw) : 0;

  return {
    carrierId: null,
    carrierInfo: {
      carrierName: payload.carrierName,
      email: payload.email,
      contactName: payload.contactName,
      dotNumber: hasFederalDot ? payload.dotNumber.trim() : "",
      businessAddress: payload.businessAddress,
      dotStatus: hasFederalDot ? payload.dotStatus : "",
      riskScore: hasFederalDot ? payload.riskScore : "",
      safetyScore: Number.isFinite(safetyScore) ? safetyScore : 0,
      ifCarrierHasFederalDot: hasFederalDot,
    },
  };
}
